
(function(){
  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('.btn').forEach(function(btn){
    btn.addEventListener('pointerdown', function(e){
      if (reduced) return;
      var r = btn.getBoundingClientRect(), size = Math.max(r.width, r.height) * 2.2;
      var el = document.createElement('span'); el.className = 'ripple';
      el.style.width = el.style.height = size + 'px';
      el.style.left = (e.clientX - r.left - size/2) + 'px';
      el.style.top = (e.clientY - r.top - size/2) + 'px';
      btn.appendChild(el);
      el.addEventListener('animationend', function(){ el.remove(); });
    });
  });
})();
(function(){
  var bar = document.getElementById('buybar');
  if (!bar) return;
  var umbral = 1.2 * innerHeight, visible = false;
  addEventListener('resize', function(){ umbral = 1.2 * innerHeight; });
  addEventListener('scroll', function(){
    var pasa = scrollY > umbral;
    if (pasa !== visible){ visible = pasa; bar.classList.toggle('show', pasa); }
  }, { passive:true });
})();
